module.exports = __webpack_public_path__ + "assets/img/enfm.d7c0b698.png";